module.exports = __webpack_public_path__ + "img/Uv.acfc8fa4.svg";